document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const elements = document.querySelectorAll(
    '.jbc-reveal, .shopify-section'
  );

  if (reduceMotion || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('jbc-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('jbc-visible');
        currentObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    }
  );

  elements.forEach((element) => {
    element.classList.add('jbc-reveal');
    observer.observe(element);
  });
});

(() => {
  if (window.location.pathname.replace(/\/$/, '') !== '/policies/privacy-policy') return;

  const updatePrivacyContact = () => {
    const contactHeading = Array.from(
      document.querySelectorAll('#MainContent h1, #MainContent h2, #MainContent h3')
    ).find((heading) => heading.textContent.trim().toLowerCase() === 'contact');
    const contactParagraph = contactHeading?.nextElementSibling;

    if (contactParagraph?.tagName === 'P') {
      contactParagraph.innerHTML =
        'Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any rights available to you, please email us at <a href="mailto:help@juiceboxcalendars.com">help@juiceboxcalendars.com</a>.';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePrivacyContact, { once: true });
  } else {
    updatePrivacyContact();
  }
})();
